import React from "react";
import { Image, ImageProps } from 'semantic-ui-react';
import companyLogo from '../../assets/images/jaymar-logo.gif';

export const CompanyLogo: React.FC<ImageProps> = (props) => {
    return (
        <Image src={companyLogo} {...props} />
    );
};